import type { WithdrawalWalletKind } from '@shared/api/contracts';

const STORAGE_KEY = 'paygatex.withdrawal-intent';

export interface WithdrawalIntentSession {
  userId: string;
  walletKind: WithdrawalWalletKind;
  idempotencyKey: string;
  intentId?: string;
  network: string;
  address: string;
  amount: string;
}

const isSession = (value: unknown): value is WithdrawalIntentSession => {
  if (!value || typeof value !== 'object') return false;
  const item = value as WithdrawalIntentSession;
  return Boolean(item.userId && item.idempotencyKey && item.walletKind && item.network && item.address && item.amount);
};

export const readIntentSession = (userId: string | undefined): WithdrawalIntentSession | null => {
  if (!userId || typeof sessionStorage === 'undefined') return null;
  try {
    const parsed: unknown = JSON.parse(sessionStorage.getItem(STORAGE_KEY) ?? 'null');
    if (!isSession(parsed) || parsed.userId !== userId) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const writeIntentSession = (session: WithdrawalIntentSession): void => {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
};

export const clearIntentSession = (): void => {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(STORAGE_KEY);
};
